exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IconClose_iconClose__3MA0g{cursor:pointer}.IconClose_iconClose__3MA0g:hover{fill:#c2c2c2}.IconClose_iconClose__3MA0g:active{fill:#999}", ""]);

// exports
exports.locals = {
	"iconClose": "IconClose_iconClose__3MA0g"
};